module.exports = __webpack_public_path__ + "static/media/astronaut.758dc41d.svg";